<template>
  <div :style="{ backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee' }">
    <header-o :model="headerData"></header-o>
    <div
      class=""
      style="margin-right: 15px; margin-left: 15px; margin-top: -170px; padding-bottom: 10px; "
    >
      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
          borderRadius: '10px'
        }"
        class="past-history-section common-section height-cus"
      >
        <!-- Winner Section End -->
        <div class=" text-center">
          <div
            class="offer-card bg-light   pos-rel "
            style="border-radius: 10px;"
          >
            <div
              :style="{
                backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
                borderRadius: '10px'
              }"
              class="history-table "
              v-if="historyData.length > 0"
            >
              <div
                class="table-responsive"
                style="box-sizing: border-box; padding: 0px 10px;"
              >
                <table class="table table-borderless">
                  <tbody>
                    <tr
                      :style="{
                        borderBottom: `1px solid ${
                          isDarkTheme ? '#ffffff' : '#C8C8C8'
                        }`
                      }"
                      v-for="item in historyData"
                    >
                      <td
                        @click="gotoConcertPage(item)"
                        class=""
                        style="font-size: 14px;"
                      >
                        <div style="display: inline-flex; width: 220px;">
                          <div
                            class="mycard"
                            style="background-color: #ffffff;"
                          >
                            <span
                              style="padding: 3px 0px;border-style: none;border-radius: 5px 5px 0px 0px;font-size: 9px;color:aliceblue"
                              :style="{
                                background: isDarkTheme ? topBgColor : bgTheme
                              }"
                              >{{
                                moment(item.ld_date).format("MMM yyyy")
                              }}</span
                            ><span style="margin:auto">{{
                              moment(item.ld_date).date()
                            }}</span>
                          </div>
                          <div
                            style="margin: 7px;
                                width: 174px;
                                text-align: initial;
                                overflow-wrap: anywhere;
                                line-height: 15px;
                                padding-top: 10px;"
                          >
                            <span style="font-weight: 600; color: #323232;">{{
                              item.title
                            }}</span>
                          </div>
                        </div>
                      </td>
                      <td
                        class="name"
                        style="font-size:14px;padding: 10px 5px;;display: flex;"
                      >
                        <!-- <img/> -->
                        <div
                          v-if="item.is_live == true"
                          style="display: flex;
                                 flex-direction: column;
                                 justify-content: flex-start;
                                  align-items: center;
                                  margin-top: 10px;
                                  padding-right: 5px;"
                        >
                          <span class="live" style="width: 40%;"></span>
                          <span
                            style="font-size: small;
                                        padding-top: 2px;"
                            >Live</span
                          >
                        </div>
                        <!-- <span
                          @click="gotoConcertPage(item)"
                          :style="{
                            display: item.is_live == true ? 'none' : ''
                          }"
                          ><img
                            src="@/assets/raffle/right-arrow.svg"
                            style="height: 35px;
                                  width: 6px;
                                  margin: 0px 10px;
                                  padding-top: 9px;"
                        /></span> -->
                        <right-arrow-icon
                          color="#585656"
                          @click="gotoConcertPage(item)"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              :style="{
                backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
                borderRadius: '10px'
              }"
              class="bg-light padding-20 margin-bottom-10 pos-rel  align-ver center-hor center-ver"
              style="min-height: 80vh"
              v-else
            >
              <img
                class="extra-large-icon margin-bottom-20"
                src="@/assets/no-data.svg"
              />
              <div>No history found.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="toast"
      class="font-bold pos-fixed pos-center-hor pull-down"
      style="width: 80%;
        padding: 5px; border-radius:10px ; background: rgba(0, 0, 0, 0.5);
        margin-bottom: 70px; color: white; display: none; z-index: 999;
        position: fixed;bottom: 0px;"
    ></div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import OverlapHeader from "@/components/overlapped-header";
import moment from "moment";
import RightArrowIcon from "../../components/right-arrow-icon.vue";

export default {
  mixins: [globals],
  components: {
    "header-o": OverlapHeader,
    RightArrowIcon
  },
  data() {
    return {
      headerData: {
        onlyHeader: true,
        showmore: false
      },
      contestId: null,
      is_shimmer: true,
      targetEventDate: null,
      historyData: [],
      moment: moment
    };
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    showShimmer: function() {
      return this.is_shimmer;
    }
  },
  beforeMount() {
    var self = this;
    if (window.addEventListener) {
      window.addEventListener("message", self.handleSDKMessage, false);
    } else {
      window.attachEvent("onmessage", self.handleSDKMessage);
    }
    this.loadDataFromCookie();
  },
  beforeDestroy() {},
  methods: {
    getRaffleHistory() {
      axios.all([this.getRaffleHistoryList()]).then(
        axios.spread(resp => {
          if (resp.status == 200) {
            this.historyData = resp.data.history;
          }
        })
      );
    },
    gotoConcertPage(item) {
      if (item.is_live == "false") {
        this.redirectTo(
          "concertDetailPage/" + item.id + `?title=${item.title}`
        );
      } else if (item.is_live) {
        document.getElementById("toast").innerHTML =
          "Result yet to be announced.";
        document.getElementById("toast").style.display = "block";
        setTimeout(function() {
          document.getElementById("toast").style.display = "none";
        }, 2000);
      }
    }
  },
  created() {
    var store_state = this.$store.state;
    store_state.showHeader = false;
    store_state.showWallet = false;
    store_state.showHistory = false;
    store_state.user.headerBalance.show = false;
    store_state.headTitle = "History";
    document.documentElement.style.setProperty(
      "--bg-color",
      this.$store.state.bg_theme
    );
    document.documentElement.style.setProperty(
      "--bg-light-color",
      this.$store.state.bg_theme + "59"
    );

    this.getRaffleHistory();
  }
};
</script>
<style scoped>
@import "../../assets/quiz-styles/quiz-styles.css";
@import "../../assets/quiz-styles/bootstrap.css";
@import "../../assets/fonts/quiz-fonts/fonts.css";
.vl {
  border-left: 1px solid #b9b9b9;
  height: 106px;
  /* position: absolute; */
  left: 50%;
  margin-left: 7px;
  top: 0;
}

.table-responsive {
  display: block;
  /* width: 100%; */
  overflow-x: auto;
}
th,
tr {
  display: flex;
  justify-content: space-between;
  padding: 10px 0px;
}

.past-history-title span {
  font-family: "Montserrat-bold", sans-serif;
  font-size: 16px;
  line-height: 19px;
  color: #373535;
  font-weight: 200;
}
.myfont {
  margin: 20px;
  font-size: 20px;
  font-weight: 700;
  font-family: "Montserrat-bold", sans-serif;
  overflow-wrap: break-word;
}
.mycard {
  width: 57px;
  height: 48px;
  border-radius: 7px;
  border-width: 0px;
  box-shadow: 0px 0px 2px;
  display: flex;
  flex-direction: column;
  margin-left: 5px;
}
.live {
  height: 10px;
  width: 25px;
  background-color: green;
  border-radius: 50%;
  display: inline-block;
}

/* Very small phones (iPhone SE, older Android) */
@media (max-width: 360px) {
  .height-cus {
    min-height: 100vh;
  }
}

/* Normal mobiles (iPhone 12/13/14/15, Samsung A/M series) */
@media (min-width: 361px) and (max-width: 480px) {
  .height-cus {
    height: 100vh;
  }
}
</style>
